export enum OrderSteps {
  Confirmation = 'ORDER_CONFIRM',
  Form = 'ORDER_FORM',
  Feedback = 'ORDER_FEEDBACK'
}

export interface BalanceAvailable {
  value: number;
  formatted: string;
}
